// @flow

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import FilterHeading from '../filterHeading';
import CheckboxFilter from '../checkboxFilter';
import FilterContainer from '../filterContainer';
import { toggleCustomFilter, isSelectedCustomFilter } from '../../../store/assortment';
import { FILTER_DELIVERY_DATE, FILTER_DELIVERY_VBMR, getTranslation } from '../../../store/assortment/helpers/applyCustomFilter';
import { getAssortmentCustomFilterHeading } from '../../../store/assortmentSettings';
import { checkVbmrAvailability, getVbmrAvailability } from '../../../store/vbmr';
import { getAvailableFilters } from '../../../store/routes';

type StateProps = {|
  isSelected: (key: string) => boolean,
  filterHeading: string,
  customFilterDeliverytime: string,
  customFilterVbmr: string,
  enabledFilters?: ?Array<string>,
  vbmrAvailable: boolean,
|};

type DispatchProps = {|
  filter: Function,
  checkVbmr: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

const showCustomFilter = (
  filterHeading: string,
  customFilterDeliverytime: string,
  enabledFilters: ?Array<string>,
): boolean => {
  if (!filterHeading.trim() || !customFilterDeliverytime.trim()
    || !(enabledFilters && enabledFilters.includes('custom_filter'))) {
    return false;
  }
  return true;
};

const FiltersColumn = ({
  filter,
  isSelected,
  filterHeading,
  customFilterDeliverytime,
  customFilterVbmr,
  enabledFilters,
  vbmrAvailable,
  checkVbmr,
}: Props) => {
  useEffect(() => {
    checkVbmr();
  }, []);

  return (
    <FilterContainer>
      {showCustomFilter(filterHeading, customFilterDeliverytime, enabledFilters) && (
        <>
          <FilterHeading>{filterHeading}</FilterHeading>
          {vbmrAvailable && <CheckboxFilter
            bucket="vbmr"
            label={customFilterVbmr}
            onChange={() => filter(FILTER_DELIVERY_VBMR)}
            isSelected={isSelected(FILTER_DELIVERY_VBMR)}
          />}
          <CheckboxFilter
            bucket="delivery"
            label={customFilterDeliverytime}
            onChange={() => filter(FILTER_DELIVERY_DATE)}
            isSelected={isSelected(FILTER_DELIVERY_DATE)}
          />
        </>
      )}
    </FilterContainer>
  );
};

FiltersColumn.defaultProps = {
  enabledFilters: [],
};

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  filter: (key: string) => dispatch(toggleCustomFilter(key)),
  checkVbmr: () => dispatch(checkVbmrAvailability(() => {}, false)),
});

const mapStateToProps = (state): StateProps => ({
  isSelected: (key: string) => isSelectedCustomFilter(state, key),
  filterHeading: getAssortmentCustomFilterHeading(state),
  customFilterDeliverytime: getTranslation(state)(FILTER_DELIVERY_DATE),
  customFilterVbmr: getTranslation(state)(FILTER_DELIVERY_VBMR),
  enabledFilters: getAvailableFilters(state),
  vbmrAvailable: getVbmrAvailability(state),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(FiltersColumn);
